import React from 'react'
import { Button, PlusIcon } from '@diversioteam/diversio-ds'

import noSurveys from 'assets/images/pulseSurveys/no-surveys.png'
import { useCreatePulseSurvey } from 'hooks/pulseSurveys/useCreatePulseSurvey'

import * as S from './noSurveys.styles'

export const NoSurveys = () => {
    const { mutate, isLoading } = useCreatePulseSurvey()

    const handleCreateSurvey = () => {
        mutate()
    }

    return (
        <S.Card component="section">
            <img src={noSurveys} alt="" />

            <S.Title>No surveys created yet</S.Title>

            <S.Description>
                Start collecting insights, feedback, or data. Build your first survey now and share it with your
                audience!
            </S.Description>

            <Button
                onClick={handleCreateSurvey}
                color="primary"
                leftIcon={<PlusIcon type="line" />}
                loading={isLoading}
            >
                Create Survey
            </Button>
        </S.Card>
    )
}
